module.exports = __webpack_public_path__ + "img/sanlam.d1b35fca.jpg";